import { useState } from "react";

export default function SynopsisSection({ paragraphs }: { paragraphs: string[] }) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? paragraphs : paragraphs.slice(0, 1);
  const hasMore = paragraphs.length > 1;

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        <i className="ri-book-open-line text-xl text-primary-600" />
        剧情介绍
      </h2>
      <div className="relative mt-5">
        <div className={`space-y-4 text-sm leading-loose text-foreground-700 md:text-[15px] ${!expanded && hasMore ? "max-h-40 overflow-hidden" : ""}`}>
          {visible.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
        {!expanded && hasMore && (
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-background-50 to-transparent" />
        )}
      </div>
      {hasMore && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-600"
        >
          {expanded ? "收起全文" : "阅读全文"}
          <i className={expanded ? "ri-arrow-up-s-line text-base" : "ri-arrow-down-s-line text-base"} />
        </button>
      )}
    </section>
  );
}